var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._class,attrs:{"data-parent":_vm.parent}},[_vm._t("default",null,{"parent":_vm.parent})],2)}
var staticRenderFns = []

export { render, staticRenderFns }